import { getQuery, getLimitOptions } from 'utilities/query';
import templateUrl from './attest.html';

export default {
  templateUrl,
  transclude: {
    actionButtons: '?actionButtons'
  },
  bindings: {
    adverseEvents: '<',
    onAttested: '&'
  },
  controller: class AttestComponent {
    constructor(EventEmitter) {
      'ngInject';

      Object.assign(this, { EventEmitter });
    }

    $onInit() {
      this.query = {
        ...getQuery(),
        take: 5
      };
      this.limitOptions = getLimitOptions();
    }

    onSubmit() {
      this.onAttested(
        this.EventEmitter({
          signature: this.signature
        })
      );
    }
  }
};



// WEBPACK FOOTER //
// ./components/app/common/attest/attest.component.js